import React from 'react'
import '../css/TopBar.css'
import logo from "../assets/images/logos/msa_full_neg.svg"
import { useLocation } from 'react-router-dom';

interface INavItem{
    name: string,
    link: string
}

function TopBar() {
    let location = useLocation();
    let navs : INavItem[] = 
    [
        {
            name: "Home",
            link: "/"
        },
        {
            name: "MSA Programme",
            link: "/MSAProgramme"
        },
        {
            name: "Employers",
            link: "/Employers",
        },
        // {
        //     name: "Cloud Skills Challenge",
        //     link: "/CloudSkillsChallenge"
        // },
        {
            name: "FAQ",
            link: "/Faq"
        }
    ]

    function navButton(navItem:INavItem, i:number) {
        let path = location.pathname
        let id = ""
        // Actually a terrible way to do nav in react :( #TechnicalDebt
        if (path === navItem.link || (path === "/" && navItem.name === "Home")){
            id = "nav-selected"
        }

        return (
            <li key={i} className="nav-item">
                <a className="nav-link py-4 mx-2 px-4" href={navItem.link} id={id}>{navItem.name}</a>
            </li>
        )
    }


    return (
        <nav className="navbar navbar-expand-lg navbar-dark">
            <a className="navbar-brand" href="/">
                <img src={logo} id="logo" width="200px" alt="MSA Logo"/>
            </a>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavDropdown">
                <ul className="navbar-nav ml-auto">
                    {
                        navs.map((navItem:any, i) => {
                            return (navButton(navItem, i))
                        })
                    }
                </ul>
            </div>
        </nav>
    )
}

export default TopBar;